
































	import Vue from 'vue';
	import Component from 'vue-class-component';
	import JyPense from '@/components/maternite/toDoList/JyPense.vue';
	import RendezVousMedicaux from '@/components/maternite/toDoList/RendezVousMedicaux.vue';
	import Examens from '@/components/maternite/toDoList/Examens.vue';

	const Props = Vue.extend({
		props: {
			//date presume grossesse
			dpg: {
				type: String,
				default: ''
			},
			moisgrossesse: {
				type: Number,
				default: 1
			}
		}
	});

	@Component({
        components: {
			JyPense,
			RendezVousMedicaux,
			Examens
        }
    })
	export default class ToDoList extends Props {
	}
